import APIClient from '@/shared/http/clients/api'

const resourceName = 'AprAnalisePreliminarRisco'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAllApr = (data = {}, limit, index, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllApr?limit=${limit}&index=${index}`, data, config)
const GetAprSelected = (idApr, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAprSelected/${idApr}`, data, config)
const GetAprMedia = (idApr, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAprMedia/${idApr}`, data, config)
const GetTemplate = (idApr, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetTemplate/${idApr}`, data, config)
const EditApr = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/EditApr`, data, config)
const GetAllStatusApr = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAllStatusApr`, data, config)
const GetAllExecutorsApr = (idApr, limit, index, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAllExecutorsApr/${idApr}?limit=${limit}&index=${index}`, data, config)
const getSignatureApr = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/getSignatureApr/${id}`, data, config)
const getSignaturesPdf = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/getSignaturesPdf/${id}`, data, config)
const GetSignatureResponsavel = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetSignatureResponsavel/${id}`, data, config)
const EditInfoAssinaturaApr = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/EditInfoAssinaturaApr`, data, config)
const GetFerramentasByAPR = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetFerramentasByAPR/${id}`, data, config)
const GetEPIByAPR = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetEPIByAPR/${id}`, data, config)
const GetRiscosEspeciaisByAPR = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetRiscosEspeciaisByAPR/${id}`, data, config)
const GetCursosNRByAPR = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetCursosNRByAPR/${id}`, data, config)

const AprAnalisePreliminarRisco = {
  GetAllApr,
  GetAprSelected,
  GetAprMedia,
  GetTemplate,
  EditApr,
  GetAllStatusApr,
  GetAllExecutorsApr,
  getSignatureApr,
  getSignaturesPdf,
  GetSignatureResponsavel,
  EditInfoAssinaturaApr,
  GetFerramentasByAPR,
  GetEPIByAPR,
  GetRiscosEspeciaisByAPR,
  GetCursosNRByAPR
}
export default AprAnalisePreliminarRisco



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprInquery.js